import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-proccess',
  templateUrl: './payment-proccess.component.html',
  styleUrls: ['./payment-proccess.component.scss']
})
export class PaymentProccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
